var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.88 272.66C13.17 278.291 0 296.057 0 316v60c0 20.55 13.85 37.93 32.71 43.29C31.58 412.02 31 404.58 31 397c0-109.814-.081-103.151.2-108.57.27-5.34.84-10.6 1.68-15.77zM479.11 272.66c1.25 7.67 1.89 15.47 1.89 23.34v101c0 7.58-.58 15.02-1.71 22.29C498.15 413.93 512 396.55 512 376v-60c0-20.61-13.94-38.04-32.89-43.34zM447 271H281.62l-50.5 25.25A45.162 45.162 0 0 1 211 301c-8.36 0-16.55-2.32-23.66-6.72C173.98 286.02 166 271.71 166 256v-74.56C107.25 186.52 61 235.96 61 296v101c0 63.41 51.59 115 115 115h160c63.41 0 115-51.59 115-115V296c0-8.48-.93-16.87-2.75-25.02-.42.02-.83.02-1.25.02zm-251 75c0 8.284-6.716 15-15 15s-15-6.716-15-15v-30c0-8.284 6.716-15 15-15s15 6.716 15 15zm90 75h-60c-8.284 0-15-6.716-15-15s6.716-15 15-15h60c8.284 0 15 6.716 15 15s-6.716 15-15 15zm60-75c0 8.284-6.716 15-15 15s-15-6.716-15-15v-30c0-8.284 6.716-15 15-15s15 6.716 15 15zM61 178.42c17.46-6.19 30-22.87 30-42.42 0-24.81-20.19-45-45-45S1 111.19 1 136c0 19.55 12.54 36.23 30 42.42 0 27.6 0 48.19-.01 63.58l11.85-3.39A145.574 145.574 0 0 1 61 207.78z",
    fill: "#f4752a",
    opacity: 1,
    "data-original": "#f4752a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 0H261c-35.841 0-65 29.159-65 65v191a15.003 15.003 0 0 0 15.001 15c2.292 0 4.591-.525 6.708-1.584L274.541 241H447c35.841 0 65-29.159 65-65V65c0-35.841-29.159-65-65-65zm-11 166H272c-8.284 0-15-6.716-15-15s6.716-15 15-15h164c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-60H272c-8.284 0-15-6.716-15-15s6.716-15 15-15h164c8.284 0 15 6.716 15 15s-6.716 15-15 15z",
    fill: "#f4752a",
    opacity: 1,
    "data-original": "#f4752a",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/chatBot.9c6192c0b2fb45a786fb06035bc0c968.svg";
export { ForwardRef as ReactComponent };